<template>
  <div class="box">
    <div class="work">
      <!--路径 -->
      <div class="path">
        <img class="path_img" src="../../../../../assets/images/path.png"/>
        <div class="path_txt">运营管理系统 > 快应用报表 > 快应用营销</div>
      </div>
      <!--查询条件-->
      <div class="condition">
        <div class="condi_line">
          <div class="condi_item_max">
            <div class="condi_item_label">日期范围:</div>
            <div class="condi_item_cnt_max">
              <el-date-picker
                      v-model="searchCondition.dateRange"
                      type="daterange"
                      value-format="yyyy-MM-dd"
                      value="yyyy-MM-dd"
                      range-separator="~"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期" 
                      style="width: 230px">
              </el-date-picker>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">应用:</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.appIds" multiple filterable  clearable  placeholder="请选择应用">
                <el-option
                        v-for="app in apps"
                        :key="parseInt(app.app_id)"
                        :label="'(' + app.app_id + ')' + app.app_name"
                        :value="parseInt(app.app_id)">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">应用类型:</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.appType" filterable  clearable  placeholder="请选择应用类型">
                <el-option
                        v-for="appType in Object.keys(appTypeMap)"
                        :key="parseInt(appType)"
                        :label="'(' + appType + ')' + appTypeMap[appType]"
                        :value="parseInt(appType)">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">投放平台：</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.issuePlatform" filterable clearable @change="handleIssuePlatFormChange" placeholder="请选择投放平台">
                <el-option
                      v-for="item in issuePlatforms"
                      :key="item.issue_platform_tag"
                      :label="item.issue_platform_name"
                      :value="item.issue_platform_tag">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">业务类型:</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.businessLine" filterable  clearable  placeholder="请选择业务类型">
                <el-option
                        v-for="key in Object.keys(businessLines)"
                        :key="key"
                        :label="businessLines[key]"
                        :value="key">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">回传类型:</div>
            <div class="condi_item_cnt">
              <el-select :diabled="!searchCondition.issuePlatform" v-model="searchCondition.issueEffect" filterable  clearable  placeholder="请选择回传类型">
                <el-option
                        v-for="item in effects"
                        :key="item.issue_effect_id"
                        :label="item.issue_effect_name"
                        :value="item.issue_effect_tag">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="condi_line">
          <div class="condi_item_max">
            <div class="condi_item_label">测评问题:</div>
            <div class="condi_item_cnt_max">
              <el-select v-model="searchCondition.measureId" filterable  clearable placeholder="请选择测评问题">
                <el-option
                        v-for="item in measures"
                        :key="item.appraise_id"
                        :label="'(' + item.appraise_id + ')' + item.appraise_title"
                        :value="item.appraise_id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">渠道:</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.channelId" filterable clearable placeholder="请选择渠道">
                <el-option
                        v-for="item in channels"
                        :key="item.channel_id"
                        :label="'(' + item.channel_id + ')' + item.channel_name"
                        :value="item.channel_id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">渠道位置:</div>
            <div class="condi_item_cnt">
              <el-input v-model="searchCondition.channelSlotId" clearable placeholder="请输入渠道位置" />
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">投放流量：</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.issueFlow" filterable clearable placeholder="请选择投放平台流量">
                <el-option
                      v-for="item in issueFlows"
                      :key="item.issue_flow_tag"
                      :label="item.issue_flow_name"
                      :value="item.issue_flow_tag">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">投放账户:</div>
            <div class="condi_item_cnt">
              <el-input v-model="searchCondition.issueAccount" clearable placeholder="查询账户信息" />
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">数据类型:</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.reportType" filterable  clearable  placeholder="请选择数据类型">
                <el-option
                        v-for="key in Object.keys(reportTypes)"
                        :key="key"
                        :label="reportTypes[key]"
                        :value="key">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="condi_line">
          <div class="condi_item" style="width: 100%">
            <div class="condi_item_label">数据维度:</div>
            <div class="condi_item_cnt" style="width: 100%">
                <el-checkbox-group v-model="searchCondition.dimensions" label="数据维度" @change="onSearch">
                  <el-checkbox label="1" name="dimensions" :key="1" style="width:70px;">日期</el-checkbox>
                  <el-checkbox label="2" name="dimensions" :key="2" style="width:70px;">应用</el-checkbox>
                  <el-checkbox label="3" name="dimensions" :key="3" style="width:70px;">应用类型</el-checkbox>
                  <el-checkbox label="4" name="dimensions" :key="4" style="width:70px;">渠道</el-checkbox>
                  <el-checkbox label="5" name="dimensions" :key="5" style="width:90px;">渠道位置</el-checkbox>
                  <el-checkbox label="6" name="dimensions" :key="6" style="width:90px;">广告帐户</el-checkbox>
                  <el-checkbox label="9" name="dimensions" :key="9" style="width:90px;">投放平台</el-checkbox>
                  <el-checkbox label="11" name="dimensions" :key="11" style="width:90px;">投放流量</el-checkbox>
                  <el-checkbox label="100" name="dimensions" :key="100" style="width:90px;" v-if="operator && operator.permissions['10100300'].indexOf('.show_rebate.')!=-1">返点</el-checkbox>
                  <el-checkbox label="99" name="dimensions" :key="99" style="width:90px;" v-if="isShowROI">预估ROI&lt;1</el-checkbox>
                  <template v-if="isShowIncrement">
                    <el-checkbox label="12" name="dimensions" :key="12" style="width:90px;">15分钟增量</el-checkbox>
                    <el-checkbox label="13" name="dimensions" :key="13" style="width:90px;">30分钟增量</el-checkbox>
                  </template>
                </el-checkbox-group>
            </div>
          </div>
        </div>

        <div class="condi_line">
          <div class="condi_item_max">
            <div class="condi_item_label"></div>
            <div class="condi_item_cnt_max">
              <el-button type="primary" @click="onSearch" style="width:100px;">查询</el-button>
              <el-button type="primary" @click="onDownload" style="width:100px;">下载</el-button>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">
              <el-button type="danger" @click="onManual" style="width:100px;">手工数据</el-button>
            </div>
            <div class="condi_item_cnt">
            </div>
          </div>
        </div>
      </div>

      <!--数据列表-->
      <div class="datalist">
        <div class="dtlst_top">
          <div class="dtlst_title">快应用营销报表</div>
        </div>
        <div class="dtlst_table">
          <el-table
            :key="'market-table-' + enableColumnFixed"
            :data="pageTable.tableData"
            :row-class-name="reportRowClass"
            :stripe="true"
            height="1000"
          >
            <el-table-column key="report_date" prop="report_date" label="日期" width="120px" :fixed="enableColumnFixed" v-if="searchCondition.dimensions.indexOf('1')!=-1">
              <template slot-scope="scope">{{scope.row.report_date}}</template>
            </el-table-column>
            <el-table-column key="app_id" prop="app_id" label="应用" width="120px" :fixed="enableColumnFixed" v-if="searchCondition.dimensions.indexOf('2')!=-1">
              <template slot-scope="scope">({{scope.row.app_id}}){{apps.find(item => item.app_id==scope.row.app_id).app_name}}</template>
            </el-table-column>
            <el-table-column key="app_type" prop="app_type" label="应用类型" width="120px" :fixed="enableColumnFixed" v-if="searchCondition.dimensions.indexOf('3')!=-1">
              <template slot-scope="scope">({{scope.row.app_type}}){{appTypeMap[scope.row.app_type]}}</template>
            </el-table-column>
            <el-table-column key="channel_id" prop="channel_id" width="150px" label="渠道" :fixed="enableColumnFixed" v-if="searchCondition.dimensions.indexOf('4')!=-1">
              <template slot-scope="scope">({{scope.row.channel_id}}){{channelsMap[scope.row.channel_id]}}</template>
            </el-table-column>
            <el-table-column key="channel_slot_id" prop="channel_slot_id" width="80px" label="渠道位置" :fixed="enableColumnFixed" v-if="searchCondition.dimensions.indexOf('5')!=-1">
              <template slot-scope="scope">{{scope.row.channel_slot_id ? scope.row.channel_slot_id : ''}}</template>
            </el-table-column>
            <el-table-column key="issue_platform" prop="issue_platform" width="80px" label="投放平台" v-if="searchCondition.dimensions.indexOf('9')!=-1">
              <template slot-scope="scope">{{scope.row.issue_platform ? issuePlatforms.find(item=>item.issue_platform_tag==scope.row.issue_platform).issue_platform_name : ''}}</template>
            </el-table-column>
            <el-table-column key="issue_flow" prop="issue_flow" width="110px" label="投放流量" v-if="searchCondition.dimensions.indexOf('11')!=-1">
              <template slot-scope="scope">{{scope.row.issue_flow ? issueFlows.find(item=>item.issue_flow_tag==scope.row.issue_flow).issue_flow_name : ''}}</template>
            </el-table-column>

            <el-table-column key="ad_cost" prop="ad_cost" label="消耗" width="120px" align="right">
              <template slot-scope="scope">
                {{scope.row.ad_cost ? parseFloat(scope.row.ad_cost * 1.0 / 1000000.0).toFixed(2) : '-'}}
              </template>
            </el-table-column>

            <template v-if="isShowIncrement">
              <el-table-column key="snap15_cost" v-if="searchCondition.dimensions.includes('12')" prop="snap15_cost" label="增量消耗(1)" width="110px" align="right">
                <template slot-scope="scope">
                  {{scope.row.snap15_cost ? parseFloat(scope.row.snap15_cost * 1.0 / 1000000.0).toFixed(2) : '-'}}
                </template>
              </el-table-column>
              <el-table-column key="snap30_cost" v-if="searchCondition.dimensions.includes('13')" prop="snap30_cost" label="增量消耗(2)" width="110px" align="right">
                <template slot-scope="scope">
                  {{scope.row.snap30_cost ? parseFloat(scope.row.snap30_cost * 1.0 / 1000000.0).toFixed(2) : '-'}}
                </template>
              </el-table-column>
            </template>

            <el-table-column key="union_pos_income" prop="union_pos_income" label="收入" width="120px" align="right">
              <template slot-scope="scope">
                {{scope.row.lunion_pos_income ? parseFloat(scope.row.lunion_pos_income * 1.0 / 1000000.0 ).toFixed(2) : 0.00}}
              </template>
            </el-table-column>
            
            <el-table-column key="app_uv" prop="app_uv" label="用户数" width="100px" align="right">
              <template slot-scope="scope">{{scope.row.app_uv}}</template>
            </el-table-column>
            <el-table-column key="app_uv,ad_cost" prop="app_uv,ad_cost" label="单人成本" width="80px" align="right">
              <template slot-scope="scope">
                {{!scope.row.ad_cost || !scope.row.app_uv ? '-' : parseFloat(scope.row.ad_cost / (scope.row.app_uv * 1000000.0)).toFixed(4)}}
              </template>
            </el-table-column>
            <el-table-column key="app_uv,union_pos_income" prop="app_uv,union_pos_income" label="ARPU" width="80px" align="right">
              <template slot-scope="scope">
                {{!scope.row.app_uv || !scope.row.lunion_pos_income ? '-' : parseFloat(scope.row.lunion_pos_income / (scope.row.app_uv * 1000000.0)).toFixed(4)}}
              </template>
            </el-table-column>

            <el-table-column key="roi1" prop="roi1" label="ROI" width="60px" align="right">
              <template slot-scope="scope">
                <el-tag style="width:50px;" type="danger" v-if="scope.row.ad_cost && (scope.row.lunion_pos_income / scope.row.ad_cost) < 1">
                  {{!scope.row.ad_cost ? '-' : parseFloat(scope.row.lunion_pos_income / scope.row.ad_cost).toFixed(2)}}
                </el-tag>
                <el-tag style="width:50px;" type="normal" v-if="!scope.row.ad_cost || scope.row.ad_cost && (scope.row.lunion_pos_income / scope.row.ad_cost) >= 1">
                  {{!scope.row.ad_cost ? '-' : parseFloat(scope.row.lunion_pos_income / scope.row.ad_cost).toFixed(2)}}
                </el-tag>
              </template>
            </el-table-column>

            <template v-if="isShowIncrement">
              <el-table-column key="snap15_roi" v-if="searchCondition.dimensions.includes('12')" prop="snap15_roi" label="增量ROI(1)" width="110px" align="right">
                <template slot-scope="scope">
                  <el-tag style="width:50px;" type="danger" v-if="scope.row.snap15_roi < 1">
                    {{!scope.row.snap15_roi ? '-' : parseFloat(scope.row.snap15_roi).toFixed(2)}}
                  </el-tag>
                  <el-tag style="width:50px;" type="normal" v-if="scope.row.snap15_roi >= 1">
                    {{!scope.row.snap15_roi ? '-' : parseFloat(scope.row.snap15_roi).toFixed(2)}}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column key="snap30_roi" v-if="searchCondition.dimensions.includes('13')" prop="snap30_roi" label="增量ROI(2)" width="110px" align="right">
                <template slot-scope="scope">
                  <el-tag style="width:50px;" type="danger" v-if="scope.row.snap30_roi < 1">
                    {{!scope.row.snap30_roi ? '-' : parseFloat(scope.row.snap30_roi).toFixed(2)}}
                  </el-tag>
                  <el-tag style="width:50px;" type="normal" v-if="scope.row.snap30_roi >= 1">
                    {{!scope.row.snap30_roi ? '-' : parseFloat(scope.row.snap30_roi).toFixed(2)}}
                  </el-tag>
                </template>
              </el-table-column>
            </template>

            <el-table-column key="ad_rebate_cost" prop="ad_rebate_cost" label="返点消耗" width="120px" align="right" v-if="searchCondition.dimensions && searchCondition.dimensions.indexOf('100')!=-1">
              <template slot-scope="scope">
                {{scope.row.ad_rebate_cost ? parseFloat(scope.row.ad_rebate_cost * 1.0 / 1000000.0).toFixed(2) : 0.00}}
              </template>
            </el-table-column>
            
            <el-table-column key="roi2" prop="roi2" label="返点ROI" width="80px" align="right" v-if="searchCondition.dimensions && searchCondition.dimensions.indexOf('100')!=-1">
              <template slot-scope="scope">
                <el-tag style="width:50px;" type="danger" v-if="scope.row.ad_rebate_cost && (scope.row.lunion_pos_income / scope.row.ad_rebate_cost) < 1">
                  {{!scope.row.ad_rebate_cost ? '-' : parseFloat(scope.row.lunion_pos_income * 1.0 / scope.row.ad_rebate_cost).toFixed(2)}}
                </el-tag>
                <el-tag style="width:50px;" type="normal" v-if="!scope.row.ad_rebate_cost || scope.row.ad_rebate_cost && (scope.row.lunion_pos_income / scope.row.ad_rebate_cost) >= 1">
                  {{!scope.row.ad_rebate_cost ? '-' : parseFloat(scope.row.lunion_pos_income * 1.0 / scope.row.ad_rebate_cost).toFixed(2)}}
                </el-tag>
              </template>
            </el-table-column>
   
            <el-table-column key="owner_id" prop="owner_id" width="300px" label="媒体帐户" v-if="searchCondition.dimensions.indexOf('6')!=-1">
              <template slot-scope="scope">
                {{scope.row.ad_new==1 ? '[新]' : ''}}({{scope.row.owner_id}}){{scope.row.owner_name}}
              </template>
            </el-table-column>

            <el-table-column key="ad_balance" prop="ad_balance" align="right" width="110px" label="媒体帐户余额" v-if="searchCondition.dimensions.indexOf('6')!=-1">
              <template slot-scope="scope">{{!scope.row.ad_balance ? '' : parseFloat(scope.row.ad_balance * 1.0 / 1000000.0).toFixed(0)}}</template>
            </el-table-column>
            <el-table-column key="ad_daily_budget" prop="ad_daily_budget" align="right" width="120px" label="媒体帐户日预算" v-if="searchCondition.dimensions.indexOf('6')!=-1">
              <template slot-scope="scope">{{!scope.row.ad_daily_budget ? '' : parseFloat(scope.row.ad_daily_budget * 1.0 / 1000000.0).toFixed(0)}}</template>
            </el-table-column>

            <el-table-column key="ad_cost,ad_click" prop="ad_click" width="110px" align="right" label="媒体CPC">
              <template slot-scope="scope">
                {{scope.row.ad_click > 0 ? parseFloat(scope.row.ad_cost / 1000000.0 / scope.row.ad_click).toFixed(2) : '-'}}
              </template>
            </el-table-column>
            <el-table-column key="ad_click,ad_impression" prop="ad_click" width="110px" align="right" label="媒体CTR">
              <template slot-scope="scope">
                {{scope.row.ad_impression > 0 ? parseFloat(scope.row.ad_click * 100.0 / scope.row.ad_impression).toFixed(2) + '%' : '-'}}
              </template>
            </el-table-column>
            <el-table-column key="ad_effect_count" prop="ad_effect_count" width="100px" align="right" label="媒体转化数">
              <template slot-scope="scope">
                {{scope.row.ad_effect_count > 0 ? scope.row.ad_effect_count : '-'}}
              </template>
            </el-table-column>
            <el-table-column key="ad_effect_count,ad_cost" prop="ad_effect_count,ad_cost" width="110px" align="right" label="媒体转化成本">
              <template slot-scope="scope">
                {{scope.row.ad_effect_count > 0 ? parseFloat(scope.row.ad_cost / 1000000.0 / scope.row.ad_effect_count).toFixed(2) : '-'}}
              </template>
            </el-table-column>
            <el-table-column key="ad_effect_count,ad_click" prop="ad_effect_count,ad_click" width="100px" align="right" label="媒体CVR">
              <template slot-scope="scope">
                {{scope.row.ad_click > 0 ? parseFloat(scope.row.ad_effect_count * 100.0 / scope.row.ad_click).toFixed(2) + '%' : '-'}}
              </template>
            </el-table-column>
            <el-table-column key="ad_price" prop="ad_price" width="80px" align="right" label="媒体出价" v-if="searchCondition.dimensions.indexOf('5')!=-1">
              <template slot-scope="scope">
                {{scope.row.ad_price > 0 ? parseFloat(scope.row.ad_price / 1000000.0).toFixed(2) : '-'}}
              </template>
            </el-table-column>
            <el-table-column key="ad_effect_count,ad_price,ad_cost" prop="ad_effect_count,ad_price,ad_cost" width="105px" align="right" label="媒体成本达成" v-if="searchCondition.dimensions.indexOf('5')!=-1">
              <template slot-scope="scope">
                {{scope.row.ad_price > 0 && scope.row.ad_effect_count > 0 && scope.row.ad_cost > 0 ? parseFloat((scope.row.ad_cost * 1.0 / scope.row.ad_effect_count) / scope.row.ad_price).toFixed(2) : '-'}}
              </template>
            </el-table-column>
            <el-table-column key="app_uv,lunion_pos_show" prop="app_uv,lunion_pos_show" width="120px" align="right" label="人均广告曝光数">
              <template slot-scope="scope">
                {{scope.row.app_uv > 0 ? parseFloat(scope.row.lunion_pos_show * 1.0 / scope.row.app_uv).toFixed(2) : '-'}}
              </template>
            </el-table-column>
            <el-table-column key="lunion_pos_income,lunion_pos_show" prop="lunion_pos_income,lunion_pos_show" width="100px" align="right" label="广告eCPM">
              <template slot-scope="scope">
                {{scope.row.lunion_pos_show > 0 ? parseFloat(scope.row.lunion_pos_income / 1000.0 / scope.row.lunion_pos_show).toFixed(2) : '-'}}
              </template>
            </el-table-column>
            <el-table-column key="app_uv,lunion_pos_click" prop="app_uv,lunion_pos_click" width="120px" align="right" label="人均广告点击数">
              <template slot-scope="scope">
                {{scope.row.app_uv > 0 ? parseFloat(scope.row.lunion_pos_click * 1.0 / scope.row.app_uv).toFixed(2) : '-'}}
              </template>
            </el-table-column>

            <el-table-column key="app_ad_impression_uv,ad_click" prop="app_ad_impression_uv,ad_click" width="100px" align="right" label="广告渗透率">
              <template slot-scope="scope">
                {{scope.row.ad_click > 0 ? parseFloat(scope.row.app_ad_impression_uv * 100.0 / scope.row.ad_click).toFixed(2) + '%' : '-'}}
              </template>
            </el-table-column>
            <el-table-column key="app_ad_request_uv,ad_click" prop="app_ad_request_uv,ad_click" width="100px" align="right" label="请求渗透率">
              <template slot-scope="scope">
                {{scope.row.ad_click > 0 ? parseFloat(scope.row.app_ad_request_uv * 100.0 / scope.row.ad_click).toFixed(2) + '%' : '-'}}
              </template>
            </el-table-column>
            <el-table-column key="app_landing_uv,ad_click" prop="app_landing_uv,ad_click" width="110px" align="right" label="落地页启动率">
              <template slot-scope="scope">
                {{scope.row.ad_click > 0 ? parseFloat(scope.row.app_landing_uv * 100.0 / scope.row.ad_click).toFixed(2) + '%' : '-'}}
              </template>
            </el-table-column>
            <el-table-column key="app_uv,ad_click" prop="app_uv,ad_click" width="100px" align="right" label="APP启动率">
              <template slot-scope="scope">
                {{scope.row.ad_click > 0 ? parseFloat(scope.row.app_uv * 100.0 / scope.row.ad_click).toFixed(2) + '%' : '-'}}
              </template>
            </el-table-column>

            <el-table-column key="app_effect_count,app_effect_total" prop="app_effect_count,app_effect_total" label="效果(占比/比例/回传/总数)" width="270px" align="right">
              <template slot-scope="scope">
                {{scope.row.app_uv==0 ? '-' : parseFloat(scope.row.app_effect_tuv * 100.0 / scope.row.app_uv).toFixed(2) + '%'}}
                /
                {{scope.row.app_effect_total==0 ? '-' : parseFloat(scope.row.app_effect_count * 100.0 / scope.row.app_effect_total).toFixed(2) + '%'}}
                /
                {{scope.row.app_effect_count}}
                /
                {{scope.row.app_effect_total}}
              </template>
            </el-table-column>

            <el-table-column key="app_effect_rate" prop="app_effect_rate" label="效果比例" width="100px" align="right" v-if="searchCondition.dimensions.indexOf('5')!=-1 || searchCondition.dimensions.indexOf('6')!=-1">
              <template slot-scope="scope">
                {{scope.row.app_effect_rate==0 ? '-' : (parseFloat(scope.row.app_effect_rate * 1.0 / 100).toFixed(2) + '%')}}</template>
            </el-table-column>

            <el-table-column key="dtlst_operation" label="操作" width="200px">
              <template slot-scope="scope">
                <div class="dtlst_operation">
                  <el-button type="primary" size="small" @click="configEffect(scope.row.channel_slot_id)">回传设置</el-button>
                  <el-button type="success" size="small" @click="adAccount(scope.row.channel_slot_id,scope.row.issue_platform,'2',scope.row.owner_id,scope.row.owner_name)" v-if="scope.row.issue_platform == 'oppo' || searchCondition.issuePlatform =='oppo' || scope.row.issue_platform == 'vivo' || searchCondition.issuePlatform =='vivo'">广告账户</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="dtlst_pagination">
            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="pageTable.pageIndex"
              :page-size="pageTable.pageSize"
              :page-sizes="[100, 200, 500, 1000]" 
              :page-count="pageTable.pageCount"
              :total="pageTable.recordTotalCount"
              @current-change="changeCurrPage"
              @size-change="changePageSize"
            >
            </el-pagination>
          </div>
        </div>
      </div>

      <!--效果数据回传设置弹窗-->
      <el-dialog title="效果数据回传设置" 
        :visible.sync="dialogConfigEffectVisible" 
        :close-on-click-modal="false"
        width="950px"
        center>
        <el-form :model="formConfigEffect" ref="formConfigEffect" :rules="configEffectRules">
          <el-form-item label="渠道位置: " prop="channelSlotId" label-width="100px">
            <el-input v-model="formConfigEffect.channelSlotId" v-if="editStatChanneSlot" autocomplete="off" style="width:200px;"></el-input>
            <el-input v-model="formConfigEffect.channelSlotId" v-if="!editStatChanneSlot" readonly autocomplete="off" style="width:200px;"></el-input>
            &nbsp;
            <el-button @click="changeChannelSlot" v-if="!editStatChanneSlot">修改</el-button>
            <el-button @click="confirmChannelSlot" v-if="editStatChanneSlot">确定</el-button>
            <el-button @click="cancelChannelSlot" v-if="editStatChanneSlot">取消</el-button>
          </el-form-item>
          <el-form-item label="回传模式：" label-width="100px">
            <el-checkbox-group v-model="effectModeSelected" onchange="configEffectModeChange();">
              <el-checkbox-button v-for="mode in effectModes" :label="mode" :key="mode">{{mode}}</el-checkbox-button>
            </el-checkbox-group>
            <el-checkbox-group v-model="effectModeSelected2" onchange="configEffectModeChange();">
              <el-checkbox-button v-for="mode in effectModes2" :label="mode" :key="mode">{{mode}}</el-checkbox-button>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="回传比例:" prop="effectRate" label-width="100px">
              <el-input v-model="formConfigEffect.effectRate" clearable autocomplete="off" style="width:200px;"></el-input>&nbsp;%
          </el-form-item>
          <el-form-item label="广告点击:" prop="effectAdClick" label-width="100px">
              <el-input v-model="formConfigEffect.effectAdClick" clearable autocomplete="off" style="width:200px;"></el-input>&nbsp;次
          </el-form-item>
          <el-form-item label="广告曝光:" prop="effectAdView" label-width="100px">
              <el-input v-model="formConfigEffect.effectAdView" clearable autocomplete="off" style="width:200px;"></el-input>&nbsp;
              <el-input v-model="formConfigEffect.effectAdView2" clearable autocomplete="off" style="width:200px;" v-if="effectModeSelected2 && effectModeSelected2.find(item => item=='用户ARPU3')!=undefined"></el-input>&nbsp;次
          </el-form-item>
          <el-form-item label="广告价格:" prop="effectAdPrice" label-width="100px">
              <el-input v-model="formConfigEffect.effectAdPrice" clearable autocomplete="off" style="width:200px;"></el-input>&nbsp;元（eCPM）
          </el-form-item>
          <el-form-item label="用户ARPU:" prop="effectArpu" label-width="100px">
              <el-input v-model="formConfigEffect.effectArpu" clearable autocomplete="off" style="width:200px;"></el-input>&nbsp;
              <el-input v-model="formConfigEffect.effectArpu2" clearable autocomplete="off" style="width:200px;" v-if="effectModeSelected2 && effectModeSelected2.find(item => item=='用户ARPU3')!=undefined"></el-input>&nbsp;元
          </el-form-item>
          <el-form-item label="访问时长:" prop="effectDuration" label-width="100px">
              <el-input v-model="formConfigEffect.effectDuration" clearable autocomplete="off" style="width:200px;"></el-input>&nbsp;秒
          </el-form-item>
          <el-form-item label="ROI:" prop="effectRoi" label-width="100px">
              <el-input v-model="formConfigEffect.effectRoi" clearable autocomplete="off" style="width:200px;"></el-input>&nbsp;
          </el-form-item>
          <el-form-item label="其他设置:" label-width="100px">
              <el-checkbox v-model="effectIgnoreOppo" style="width:100px;">忽略OPPO</el-checkbox>
              <el-checkbox v-model="effectIgnoreVivo" style="width:100px;">忽略VIVO</el-checkbox>
              <el-checkbox v-model="effectUnifySwitch" style="width:100px;">统一回传</el-checkbox>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="onCancelConfigEffect">取 消</el-button>
          <el-button type="primary" @click="submitConfigEffect('formConfigEffect')">确 定</el-button>
          <el-button type="info" @click="showOperateLogs">历史操作</el-button>
        </div>
      </el-dialog>

      <!--操作日志查询-->
      <el-dialog title="效果数据回传历史修改记录" 
        :visible.sync="dialogOperateLogVisible" 
        :close-on-click-modal="false"
        width="1000px"
        center>
        
        <div class="dtlst_table">
          <el-table
            :data="operateLogs.tableData"
            stripe
          >
            <el-table-column prop="operate_time" label="时间" width="200px">
              <template slot-scope="scope">{{scope.row.operate_time}}</template>
            </el-table-column>
            <el-table-column prop="operator_name" label="操作人" width="150px">
              <template slot-scope="scope">{{scope.row.operator_name}}</template>
            </el-table-column>
            <el-table-column prop="change_illustrate" label="操作详情" width="600px">
              <template slot-scope="scope">
                <span style="white-space:pre-line;">
                  {{scope.row.change_illustrate}}
                </span>
              </template>
            </el-table-column>
          </el-table>
          <div class="dtlst_pagination">
            <el-select v-model="operateLogs.dateRange" @change="loadOperateLogs()" placeholder="请选择日志时间范围">
              <el-option
                v-for="item in logDateRange"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="operateLogs.pageIndex"
              :page-size="operateLogs.pageSize"
              :page-sizes="[100, 200, 500, 1000]" 
              :page-count="operateLogs.pageCount"
              :total="operateLogs.recordTotalCount"
              @current-change="changeOperateLogCurrPage"
              @size-change="changeOperateLogPageSize"
            >
            </el-pagination>
          </div>
        </div>


      </el-dialog>

      <!-- 广告账户弹窗：标题展示「广告账户 - 渠道号 - 媒体账户」便于区分 -->
      <el-dialog :title="adAccountDialogTitle" 
        :visible.sync="dialogAdAccount"
        v-loading="dialogLoading" 
        element-loading-text="提交中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
        style="min-height: 100px;"
        width="85%"
        :close-on-click-modal="false">
        <div class="account-info-box">
          <div class="account-info-item account-info-txt">账户余额(元)：{{ acCountBalance }}</div>
          <div class="account-info-item account-info-txt">今日消耗(元)：{{ adConsumption }}</div>
          <div class="account-info-item">
            <div class="account-info-txt editable-field" @dblclick="startEditingDailyCap">账户日预算(元)：
              <span v-if="isEditingDailyCap">
                {{ editingDailyCapValue == '-1' || editingDailyCapValue == null ? '不限' : editingDailyCapValue ? parseFloat(editingDailyCapValue).toFixed(2) : editingDailyCapValue }}
              </span>
            </div>
            <!-- 修改账户日预算弹窗 -->
            <div v-if="!isEditingDailyCap" class="dailycap_mask">
              <div class="dailycap">
                <div class="dailycap_header">修改账户日预算</div>
                <div class="dailycap_body">
                  <div class="dailycap_radio_row">
                    <label class="dailycap_radio">
                      <el-radio v-model="radio" label="1" @change="handleRadioChange">不限</el-radio>
                    </label>
                    <label class="dailycap_radio">
                      <el-radio v-model="radio" label="2" @change="handleRadioChange">自定义</el-radio>
                    </label>
                  </div>

                  <div class="dailycap_input_row" v-if="showBudgetModal">
                    <input
                      v-model.number="editingDailyCapValue" 
                      autofocus
                      type="number">
                    <div class="input_suffix">元/天</div>
                  </div>
                </div>

                <div class="dailycap_footer">
                  <button class="btn-plain" @click="closeBudgetModal">取 消</button>
                  <button class="btn-green" @click="confirmBudget">确 定</button>
                </div>
              </div>
            </div>

          </div>
        </div>
        <!-- 操作按钮 -->
        <div class="account-info-box">
          <el-button type="primary" @click="batchToggleSwitch(0)">批量开</el-button>
          <el-button type="primary" @click="batchToggleSwitch(1)">批量关</el-button>
          <el-button type="primary" @click="batchUpdatePrice">批量修改出价</el-button>
          <div style="margin-left: 10px;">
            <el-select v-model="adGroupValue" @change="handleAdGroup" placeholder="筛选广告组">
              <el-option
                v-for="item in adGroupOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <!-- 广告账户列表 -->
        <el-table :data="gridData" @selection-change="handleSelectionChange">
          <el-table-column type="selection"></el-table-column>
          <el-table-column label="广告计划" width="220">
            <template slot-scope="scope">
              {{ "(" + scope.row.planId + ")" }} - {{ scope.row.planName }}
            </template>
          </el-table-column>
          <el-table-column label="广告组" width="220">
            <template slot-scope="scope">
              {{ "(" + scope.row.adGroupId + ")" }} - {{ scope.row.adGroupName }}
            </template>
          </el-table-column>
          <el-table-column label="开关" width="100" header-align="right" align="right">
            <template slot-scope="scope">
              <el-switch 
                v-model="scope.row.switch"
                :active-value="0"
                :inactive-value="1" 
                active-color="#13ce66" 
                inactive-color="#848484" 
                @change="handleSwitchChange(scope)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column property="ocpcPrice" label="出价" width="300" header-align="center" align="center">
            <template slot-scope="scope" style="display: flex; align-items: center; gap: 8px;">
              <!-- 非编辑状态：显示「分」转「元」（保留2位小数） -->
              <span style="width: 100px; text-align: center;"
                v-if="!scope.row.isEditingPrice" 
                @dblclick="handlePriceDbClick(scope)">
                {{scope.row.bidType == 1 ? 'ROI系数' : '价格'}} : {{ scope.row.bidType == 1  ? parseFloat(scope.row.roiFactor / 100).toFixed(2) : parseFloat(scope.row.ocpcPrice / 100).toFixed(2) }} 
                <!-- 直接用分计算，避免类型问题 -->
              </span>
              <!-- 编辑状态：输入框（动态ref，避免冲突） -->
              <el-input 
                v-else
                v-model="scope.row.ocpcPriceEdit"
                @input="handlePriceInput(scope)"
                style="width: 140px; margin-right: 10px;"
                :ref="`priceInput-${scope.$index}`"
                autofocus
              ></el-input>
              <!-- 确认按钮：点击才触发修改 -->
              <el-button v-if="scope.row.isEditingPrice" plain size="mini" type="primary" @click="scope.row.isEditingPrice = false">取消</el-button>
              <el-button v-if="scope.row.isEditingPrice" plain size="mini" type="primary" @click="handlePriceConfirm(scope)">确认</el-button>
            </template>
          </el-table-column>
          <!-- 其他列保持不变 -->
          <el-table-column property="cost" label="消耗" width="80" header-align="right" align="right">
            <template slot-scope="scope">
              {{ !scope.row.cost ? '-' : parseFloat(scope.row.cost / 100).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column property="adEffectCount" label="效果数" width="80" header-align="right" align="right"></el-table-column>
          <el-table-column label="效果成本" width="80" header-align="right" align="right">
            <template slot-scope="scope">
              {{ !scope.row.cost || scope.row.cost === 0 || !scope.row.adEffectCount || scope.row.adEffectCount === 0 ? '-' : parseFloat(scope.row.cost / 100 / scope.row.adEffectCount).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="点击成本" width="80" header-align="right" align="right">
            <template slot-scope="scope">
              {{ !scope.row.cost || scope.row.cost === 0 || scope.row.click === 0 ? '-' : parseFloat(scope.row.cost / 100 / scope.row.click).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column property="clickRate" label="点击率" width="80" header-align="right" align="right">
            <template slot-scope="scope">
              {{ !scope.row.clickRate || scope.row.clickRate === 0 ? '-' : `${parseFloat(scope.row.clickRate).toFixed(2)}%` }}
            </template>
          </el-table-column>
          <el-table-column property="clickRate" label="快应用地址" width="140" header-align="center" align="center">
            <template slot-scope="scope">
              <el-button type="primary" v-if="platform == 'oppo' && !scope.row.rpkDeepLink" plain @click="getrpkDeepLink(scope)">获取地址</el-button>
              <el-tooltip v-if="platform == 'oppo' && scope.row.rpkDeepLink" :content="scope.row.rpkDeepLink || '-'" placement="top">
                <div class="text-ellipsis" >{{ scope.row.rpkDeepLink ? scope.row.rpkDeepLink : '-' }}</div>
              </el-tooltip>
              <el-tooltip v-if="platform == 'vivo'" :content="scope.row.rpkDeepLink || '-'" placement="top">
                <div class="text-ellipsis">{{ !scope.row.rpkDeepLink ? '-' : scope.row.rpkDeepLink }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import {
  getCurrDate,
  getBeforeDate
} from '../../../../../assets/scripts/date2string';

import moment from 'moment'
import tableFixedMobile from '@/mixins/tableFixedMobile'

export default {
  mixins: [tableFixedMobile],
  data() {
    return {
      showBudgetModal: false,
      radio: '1',
      adGroupOptions: [{
        value: '1',
        label: '所有广告组',
      }, {
        value: '2',
        label: '仅有消耗广告组',
      }],
      adGroupValue: '2',                // 初始默认选中2
      prevValue: '2',                   // 记录上一次选中值，用于取消时回退
      prevDailyCap: null,               // 记录上一次选中值，用于取消时回退
      isSelectDisabled: false,          // 控制整个选择器是否禁用
      editingDailyCapValue: null,       // 账户封顶
      acCountBalance: null,             // 账户余额
      adConsumption: null,              // 今日消耗
      isEditingDailyCap: true,
      dialogLoading: false,
      channelSlotIdAdAccount: null,
      // 弹窗标题用的媒体账户信息（owner_id / owner_name）
      adAccountOwnerId: null,
      adAccountOwnerName: null,
      selectedRows: [],           // 存储多选的行数据
      dialogAdAccount: false,     // 广告账户弹窗开关
      gridData: [],
      
      // 操作员对象
      operator: null,
      
      // 分页表格
      pageTable: {
        pageIndex: 1,         // 当前页索引
        pageSize: 200,        // 本页显示数量
        pageCount: 1,         // 分页总数
        recordTotalCount: 0,  // 记录
        tableData: [],        // 应用列表数据
      },

      // 搜索的参数
      searchCondition: {
        reportType: null,         // 数据类型
        appIds: null,             // 应用集合
        appType: null,            // 应用类型
        dateRange: null,          // 日期范围
        channelId: null,          // 渠道ID
        channelSlotId: null,      // 渠道位置ID
        issuePlatform: null,      // 投放平台
        issueFlow: null,          // 投放平台流量
        issueAccount: null,       // 投放帐户
        measureId: null,          // 测评ID
        businessLine: 'quickapp', // 业务线
        dimensions: ["1"],        // 数据维度
        issueEffect:'',           // 回传类型
      },
      
      // 效果数据回传
      dialogConfigEffectVisible: false,
      formConfigEffect: {
        operatorId: null,
        channelSlotId: null,
        effectMode: null,
        effectRate: null,
        effectAdClick: null,
        effectAdView: null,
        effectAdView2: null,
        effectArpu: null,
        effectArpu2: null,
        effectAdPrice: null,
        effectDuration: null,
        effectRoi: null,
        effectIgnore: null,
        effectUnify: null,
      },
      effectIgnoreOppo: false,
      effectIgnoreVivo: false,
      effectUnifySwitch: false,
      
      editChannelSlotId: null,
      editStatChanneSlot: false,

      effectModes: ['广告点击','广告曝光','用户ARPU','广告价格','访问时长','广告曝光&价格','ROI'],
      effectModeSelected: [],
      effectModes2: ['广告点击&价格','用户ARPU2','广告价格2','广告曝光&价格2','收入ROI','ROI修正'],
      effectModeSelected2: [],
      
      // 效果数据回传校验规则
      configEffectRules: {
          channelSlotId: [
              { required: true, message: '无效的渠道位置', trigger: 'blur' }
          ],
          effectMode: [
              { required: true, message: '请选择效果回传模式', trigger: 'blur' }
          ],
          effectRate: [
              { required: true, message: '请输入效果回传比例', trigger: 'blur' }
          ]   
      },

      apps: [],                 // 应用集合
      channels: [],             // 渠道
      channelsMap: {},          // 渠道映射
      measures: null,           //测评列表
      effects:[],               // 回传类型列表

      // 投放平台和流量列表
      issuePlatforms: [],
      issueFlows: [],
      
      // 报表类型映射表
      reportTypeMap: {
        'app': "应用",
        'ad': "广告",
        'union': "联盟",
        'baidu': "百度"
      },

      // 应用类型
      appTypeMap: {
        5: "H5",
        61: "OPPO",
        62: "VIVO",
        63: "小米",
        65: "华为",
        66: "荣耀",
      },

      // 业务线
      businessLines: {
        'quickapp':     '快应用',
        'appraise_pay': '付费测评'
      },

      // 报表类型
      reportTypes: {
        'oppo':         'OPPO推广',
        'oppo_union':   'OPPO联盟',
        'vivo':         'VIVO推广',
        'vivo_union':   'VIVO联盟',
        'huawei':       '华为推广',
        'huawei_union': '华为联盟',
        'gdt':          '广点通推广',
        'gdt_adnet':    '广点通优量汇',
        'baidu':        '百度推广',
        'baidu_union':  '百度联盟',
        'kuaishou':     '快手推广',
        'toutiao':      '头条推广',
        'qtt':          '趣头条推广',
        'wifi':         'WI-FI推广',
        'uc':           'UC推广',
        'maplehaze':    '枫岚ADX',
        'alipay':       '支付宝灯火',
        'iqiyi':        '爱奇艺推广',
        'weibo':        '微博推广',
        'domob':        '多盟',
      },

      // 操作日志
      dialogOperateLogVisible: false,
      operateLogs: {
        dateRange: 3,
        pageIndex: 1,         // 当前页索引
        pageSize: 100,        // 本页显示数量
        pageCount: 1,         // 分页总数
        recordTotalCount: 0,  // 记录
        tableData: [],        // 应用列表数据
      },
      logDateRange: [{
          value: 3,
          label: '最近3天'
        },
        {
          value: 7,
          label: '最近7天'
        },
        {
          value: 15,
          label: '最近15天'
        },
        {
          value: 30,
          label: '最近30天'
        }
      ],

      // 当前投放平台（广告账户专用）
      platform: 'oppo',
    };
  },
  computed: {
    // 广告账户弹窗标题：广告账户 - 渠道号 - 媒体账户
    adAccountDialogTitle() {
      let title = '广告账户 - ' + (this.channelSlotIdAdAccount || '');
      if (this.adAccountOwnerId) {
        title += ' - (' + this.adAccountOwnerId + ')' + (this.adAccountOwnerName || '');
      }
      return title;
    },
    // 是否展示增量数据
    isShowIncrement() {
      try {
        const today = moment(new Date()).format('YYYY-MM-DD')
        const beginDate = moment(this.searchCondition.dateRange[0]).format('YYYY-MM-DD')
        const endDate = moment(this.searchCondition.dateRange[1]).format('YYYY-MM-DD')
        return beginDate ===today && endDate === today && this.searchCondition.dimensions.includes('1')&& this.searchCondition.dimensions.includes('5')
      } catch (e) {
        return false
      }
    },
    // 是否展示roi筛选项
    isShowROI() {
      try {
        const today = moment(new Date()).format('YYYY-MM-DD')
        const beginDate = moment(this.searchCondition.dateRange[0]).format('YYYY-MM-DD')
        const endDate = moment(this.searchCondition.dateRange[1]).format('YYYY-MM-DD')
        return beginDate ===today && endDate === today && this.searchCondition.dimensions.includes('5')
      } catch (e) {
        return false
      }
    },
    // 是否展示roi列
    isShowROIColumn() {
      return this.isShowROI && this.searchCondition.dimensions.includes('99')
    },
  },
  created() {
    // 从缓存中恢复操作员对象
    let operatorSerial = localStorage.getItem('operator');
    if(operatorSerial==null || operatorSerial==undefined || operatorSerial=='') {
      // 返回登录页面
      this.$router.push('/');
      return;
    }
    this.operator = JSON.parse(operatorSerial);
    // 从缓存中恢复查询条件
    let sc = localStorage.getItem('sc.quickstat.market');
    if(sc && sc.length>0) {
      let lsc = JSON.parse(sc);
      if(lsc.timestamp && (new Date().getTime() - lsc.timestamp) <= 30 * 60 * 1000) {
        this.searchCondition = lsc.data;
      } else {
        localStorage.removeItem('sc.quickstat.market');
      }
    }
    // 初始化数据
    this.getInitDate();
    this.initApps();
    this.initChannels();
    this.initMeasures();
    this.initIssuePlatforms();
    this.loadIssueFlows();
    this.initEffects()
    // 获取用数据
    this.getStatLuckyOppoData(1);
  },

  methods: {
    // 获取oppo广告组的deeplink链接
    async getrpkDeepLink(scope) {
      const row = scope.row;
      try {
        let res = await this.$api.apiGetdeeplink({channelSlotId:this.channelSlotIdAdAccount,operatorId: this.operator.operatorId,adGroupId:row.adGroupId});
        if(res && res.result == 1 && res.content) {
          this.$set(row, 'rpkDeepLink', res.content.deeplink);
          this.$message('获取成功',"success");
        }else {
          this.$message('获取失败，请重试',"error");
        }
      } catch (error) {
        this.$message('获取失败，请重试',"error");
      }
      
    },

    // 取消修改日预算
    closeBudgetModal() {
      this.isEditingDailyCap = true;
      this.$message('已取消','info');
      this.editingDailyCapValue = this.prevDailyCap;
    },
    
    // 确认修改日预算
    confirmBudget() {
      // 确认操作：调用API更新
      try {
        this.dialogLoading = true;
        if(this.radio == 1) {
          this.gApiUpdbudget(this.channelSlotIdAdAccount,this.operator.operatorId,'-1');
          this.prevDailyCap = null;
          this.editingDailyCapValue = null;
        }else {
          this.gApiUpdbudget(this.channelSlotIdAdAccount,this.operator.operatorId,this.editingDailyCapValue);
          this.prevDailyCap = this.editingDailyCapValue;
        }
        this.dialogLoading = false;
        this.isEditingDailyCap = true;
        this.$message('更新成功',"success");
      } catch (error) {
        this.$message('更新失败，请重试',"error");
        // 接口失败时回退选中值
        this.editingDailyCapValue = this.prevDailyCap;
      }
    },

    // 展示自定义编辑框
    handleRadioChange() {
      if (this.radio == "2") {
        // 选择自定义时，显示输入框
        this.showBudgetModal = true;
        // 如果当前值为不限，清空输入框等待用户输入
        if (this.editingDailyCapValue == null || this.editingDailyCapValue == '-1' || this.editingDailyCapValue === '') {
          this.editingDailyCapValue = '';
        }
      } else {
        // 选择不限时，隐藏输入框
        this.showBudgetModal = false;
      }
    },
    
    // 获取当日消耗
    async gApiGetadcost(channelSlotId,platform) {
      // 当日消耗
      let res = await this.$api.apiGetadcost({channelSlotId,platform,operatorId: this.operator.operatorId});
      if(res && res.result==1 && res.content) {
        this.adConsumption = res.content.adCost > 0 ? res.content.adCost*1.0 / 100 : 0
        this.acCountBalance = res.content.adBalance > 0 ? res.content.adBalance*1.0 / 100 : 0
        this.prevDailyCap = res.content.adDailyBudget && res.content.adDailyBudget > 0 ? res.content.adDailyBudget*1.0 / 100 : res.content.adDailyBudget == 0 ? 0 : res.content.adDailyBudget;
        this.editingDailyCapValue = res.content.adDailyBudget && res.content.adDailyBudget > 0 ? res.content.adDailyBudget*1.0 / 100 : res.content.adDailyBudget == 0 ? 0 : res.content.adDailyBudget;
        this.radio = this.editingDailyCapValue == null || this.editingDailyCapValue == '-1' ? "1" : "2";
      }
    },

    // 设置当日消耗
    async gApiUpdbudget(channelSlotId,operatorId,accDayBudget) {
      if (accDayBudget == '-1') {
        accDayBudget = '-1';
      } else if (accDayBudget && accDayBudget != 'null') {
        accDayBudget = parseFloat(accDayBudget) * 100;
      }
      await this.$api.apiUpdbudget({channelSlotId,platform:this.platform,operatorId,accDayBudget});
    },

    // 筛选广告组
    handleAdGroup(e) {
      // 弹出确认提示框
      this.$confirm('确定要切换广告组吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        // 确认操作：调用API更新
        try {
          this.dialogLoading = true;
          // 1. 调用接口（示例）
          await this.adAccount(this.channelSlotIdAdAccount,this.platform,e);
          // 2. 记录当前值为上一次值
          this.prevValue = e;
          this.dialogLoading = false;
          this.$message('更新成功',"success");
        } catch (error) {
          this.$message('更新失败，请重试',"error");
          // 接口失败时回退选中值
          this.adGroupValue = this.prevValue;
        }
      }).catch(() => {
        // 取消操作：回退到之前的选中值
        this.adGroupValue = this.prevValue;
        this.$message('已取消操作',"info");
      });
      
    },

    // 编辑账户封顶
    startEditingDailyCap() {
      this.isEditingDailyCap = false;
      // 判断当前值：null、'-1'、空字符串都表示不限
      const isUnlimited = this.editingDailyCapValue == null 
        || this.editingDailyCapValue == '-1' 
        || this.editingDailyCapValue == ''
        || this.editingDailyCapValue == undefined;
      
      if (isUnlimited) {
        this.showBudgetModal = false;
        this.radio = "1"; // 不限
      } else {
        this.showBudgetModal = true;
        this.radio = "2"; // 自定义
      }
    },

    // 确认修改广告组开关（优化：等待接口返回后再更新本地状态）
    async updateAdSwitch(channelSlotId, adGroupId, onoff) {
      this.dialogLoading = true;
      try {
        let res = await this.$api.updateSwitch({ channelSlotId, platform: this.platform, adGroupIds: adGroupId, onoff, operatorId: this.operator.operatorId });
        if(res && res.result == 1) {
          this.$message("成功修改广告组开关","success");
          // 接口成功后再更新本地状态（避免接口失败但本地已变）
          if (Array.isArray(this.gridData)) {
            // 统一处理 adGroupId：转换为字符串数组
            const adGroupIdArray = typeof adGroupId === 'string' 
              ? adGroupId.split(',').map(id => String(id.trim()))
              : [String(adGroupId)];
            
            this.gridData.forEach(row => {
              if (adGroupIdArray.includes(String(row.adGroupId))) {
                row.switch = onoff;
              }
            });
          }
        }else {
          this.$message(`更新开关失败：${res.message || "网络错误"}`, "error");
        }
      } catch (err) {
        console.log(err);
        this.$message(`更新开关失败：${err.message || "网络错误"}`, "error");
      } finally {
        this.dialogLoading = false;
      }
    },

    // 确认修改广告组转化出价（优化：参数校验）
    async updateAdAccount(channelSlotId, bidType, adGroupId, price) {
      if (typeof adGroupId === 'number' && !isNaN(adGroupId)) {
        adGroupId =  String(adGroupId); // 数字类型 → 转为字符串
      }
      if (!price || isNaN(price)) {
        this.$message("无效的价格参数",'error');
        return;
      }
      const priceInCent = Math.round(Number(price) * 100); // 转为分（避免浮点数精度问题）
      this.dialogLoading = true;
      try {
        let res = await this.$api.updateAdPrice({ channelSlotId,platform:this.platform, bidType, adGroupIds: adGroupId, price: priceInCent, operatorId: this.operator.operatorId});
        if(res && res.result == 1) {
          this.$message("修改出价成功","success");
          // 接口成功后更新本地状态
          if (Array.isArray(this.gridData)) {
            this.gridData.forEach(row => {
              if (adGroupId.includes(row.adGroupId)) {
                if (bidType == 1) {
                  row.roiFactor = priceInCent; // ROI系数类型，更新 roiFactor
                } else {
                  row.ocpcPrice = priceInCent; // 价格类型，更新 ocpcPrice
                }
              }
            });
          }
        }else {
          this.$message(`更新出价失败：${res.message || "网络错误"}`,"error");
        }
      } catch (err) {
        console.log('更新出价失败：err----',err);
        this.$message(`更新出价失败：${err.message || "网络错误"}`,"error");
      } finally {
        this.dialogLoading = false;
      }
    },

    // 多选变化时，更新选中行数据
    handleSelectionChange(rows) {
      this.selectedRows = rows || [];
    },

    handleSwitchChange(scope) {
      this.updateAdSwitch(this.channelSlotIdAdAccount, scope.row.adGroupId, scope.row.switch);
    },

    // 批量修改开关状态
    batchToggleSwitch(evt) {
      if (this.selectedRows.length === 0) {
        this.$message('请先选择要操作的行',"warning");
        return;
      }
      const adGroupIds = this.selectedRows.map(row => row.adGroupId);
      // evt: 0=开启, 1=关闭
      const actionText = evt === 0 ? '开启' : '关闭';
      this.$confirm(`确定要${actionText}选中的广告组吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.updateAdSwitch(this.channelSlotIdAdAccount, adGroupIds.join(','), evt);
      }).catch(() => {
        // 取消操作不做处理
      });
    },
    
    // 批量修改出价（优化：等待接口返回后更新）
    batchUpdatePrice() {
      if (this.selectedRows.length === 0) {
        this.$message('请先选择要操作的行',"warning");
        return;
      }
      // 检查bidType是否一致
      const firstBidType = this.selectedRows[0]?.bidType;
      const isConsistent = this.selectedRows.every(row => row.bidType == firstBidType);
      if (!isConsistent) {
        this.$message('出价类型不一致，请重新选择！',"warning");
        return;
      }
      // 保存当前出价类型
      const consistentBidType = firstBidType;
      this.$prompt('请输入要批量设置的出价', '提示', {
        inputType: 'number',
        inputPlaceholder: '输入出价（最多两位小数）',
        inputPattern: /^\d+(\.\d{1,2})?$/,
        inputErrorMessage: '请输入有效的出价（最多两位小数）'
      }).then(({ value }) => {
        const price = Number(value).toFixed(2); // 元
        const adGroupIds = this.selectedRows.map(row => row.adGroupId);
        this.updateAdAccount(this.channelSlotIdAdAccount,consistentBidType, adGroupIds.join(','), price);
      }).catch(() => {
        this.$message('已取消批量修改出价','info');
      });
    },

    // 双击进入编辑状态（优化：用单独字段存储编辑值，避免污染原始数据）
    handlePriceDbClick(scope) {
      const row = scope.row;
      row.isEditingPrice = true;
      // 原始价格是「分」，转为「元」用于编辑（保留2位小数）
      row.ocpcPriceEdit = row.bidType == 1  ? (row.roiFactor / 100).toFixed(2) : (row.ocpcPrice / 100).toFixed(2);
      // 聚焦当前行的input（动态ref）
      this.$nextTick(() => {
        const inputRef = this.$refs[`priceInput-${scope.$index}`];
        if (inputRef) {
          inputRef.focus();
          // 选中所有文本，方便用户直接输入新值
          inputRef.select();
        }
      });
    },

    // 实时过滤价格输入（修复：支持正常的小数点输入）
    handlePriceInput(scope) {
      const row = scope.row;
      let value = String(row.ocpcPriceEdit || '');

      // 基础过滤：只保留数字和小数点
      value = value.replace(/[^\d.]/g, '');
      
      // 处理开头的小数点
      if (value.startsWith('.')) {
        value = '0' + value;
      }
  
      // 处理多个小数点
      const dotIndex = value.indexOf('.');
      if (dotIndex !== -1) {
        const beforeDot = value.substring(0, dotIndex);
        const afterDot = value.substring(dotIndex + 1);
        value = beforeDot + '.' + afterDot.replace(/\./g, '');
      }
      
      // 限制小数位数
      if (value.includes('.')) {
        const parts = value.split('.');
        if (parts[1] && parts[1].length > 2) {
          value = parts[0] + '.' + parts[1].substring(0, 2);
        }
      }

      // 将处理后的值赋回给编辑字段
      row.ocpcPriceEdit = value;
    },

    // 出价确认（修复：正确处理字符串到数字的转换）
    handlePriceConfirm(scope) {
      const row = scope.row;
      
      // 空值/无效值校验
      if (row.ocpcPriceEdit === '' || row.ocpcPriceEdit === '.') {
        this.$message('请输入有效的价格',"error");
        return; 
      }
      
      // 转换为数字进行验证
      const priceValue = parseFloat(row.ocpcPriceEdit);
      if (isNaN(priceValue) || priceValue < 0) {
        this.$message('请输入有效的非负数字',"error");
        return; 
      }
      
      // 格式化价格（元，保留2位小数）
      const priceInYuan = priceValue.toFixed(2);
      
      // 关闭编辑状态
      row.isEditingPrice = false;
      
      // 调用更新接口（传入元，内部转为分） 
      this.updateAdAccount(this.channelSlotIdAdAccount, row.bidType, row.adGroupId, priceInYuan);
    },

    // 广告账户详情；ownerId/ownerName 用于弹窗标题展示媒体账户
    async adAccount(channelSlotId,platform,groupSelector,ownerId,ownerName) {
      // 保存当前投放平台
      this.platform = platform;
      this.channelSlotIdAdAccount = channelSlotId;
      // 仅在传入时更新，切换广告组筛选时保留原媒体账户信息
      if (ownerId !== undefined) {
        this.adAccountOwnerId = ownerId;
        this.adAccountOwnerName = ownerName;
      }
      this.adGroupValue = groupSelector;
      // 当日消耗
      this.gApiGetadcost(channelSlotId,platform)
      if (!channelSlotId) {
        this.$message("请选择具体渠道位置","warning");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        target: '.box'
      });
      try {
        const res = await this.$api.apiLuckyStatAdAccount({ channelSlotId,platform,operatorId: this.operator.operatorId,groupSelector});
        if (res.result === 1 && Array.isArray(res.content)) {
          // 初始化编辑状态和价格（确保ocpcPrice为数字类型）
          this.gridData = res.content.map(item => ({
            ...item,
            isEditingPrice: false,
            ocpcPrice: Number(item.ocpcPrice) || 0, // 确保是数字（分）
            switch: item.switch != null ? Number(item.switch) : 1,// 确保是数字
            ocpcPriceEdit: '' // 编辑用的临时字段
          }));
          this.dialogAdAccount = true;
        } else {
          this.$message("获取数据失败","error");
        }
      } catch (err) {
        this.$message(`加载失败：${err.message || "网络错误"}`,"error");
      } finally {
        loading.close();
      }
    },

    // 表格行样式
    reportRowClass({row}) {
      if(row.ad_cost != null && row.ad_cost != 0) {
        if(row.lunion_pos_income / row.ad_cost < 2) {
          return 'table_row_danger';
        }
      }
      return '';
    },
    
    // 初始化应用
    async initApps(){
      // 清空当前集合数据
      this.apps = [];
      // 调用接口
      let res = await this.$api.apiCommonApps();
      // 应用数据存进data
      this.apps = res.content;
    },

    async initChannels() {
      // 清空当前渠道
      this.channels = [];
      // 调用接口
      let res = await this.$api.apiCommonChannels();
      // 保存结果
      this.channels = res.content;
      // 保存到集合中
      this.channels.forEach((channel) => {
        this.channelsMap[channel.channel_id] = channel.channel_name;
      });
    },

    // 初始化测评
    async initMeasures() {
      // 清空当前测评
      this.measures = [];
      // 调用接口
      let res = await this.$api.apiCommonAppraises();
      // 保存结果
      this.measures = res.content;
    },

    // 初始化发布平台
    async initIssuePlatforms() {
      // 清空当前渠道
      this.issuePlatforms = [];
      // 调用接口
      let res = await this.$api.apiCommonIssuePlatforms();
      // 保存结果
      this.issuePlatforms = res.content;
    },
    // 获取回传类型列表
    async initEffects() {
      this.effects = [];
      // 调用接口
      let params = {};
      if(this.searchCondition.issuePlatform!=null && this.searchCondition.issuePlatform!='') {
        params['issuePlatformTag'] = this.searchCondition.issuePlatform;
      } else {
        return
      }
      let res = await this.$api.apiCommonIssueEffects(params);
      // 保存结果
      this.effects = res.content;
    },
    handleIssuePlatFormChange() {
      this.searchCondition.issueEffect = null;
      this.initEffects();
      this.searchCondition.issueFlow = null;
      this.loadIssueFlows();
    },
    // 加载发布平台流量类型
    async loadIssueFlows() {
      // 清空当前流量类型
      this.issueFlows = [];
      // 调用接口
      let params = {};
      if(this.searchCondition.issuePlatform!=null && this.searchCondition.issuePlatform!='') {
        params['issuePlatformTag'] = this.searchCondition.issuePlatform;
      }
      let res = await this.$api.apiCommonIssueFlows(params);
      // 保存结果
      this.issueFlows = res.content;
    },

    async getStatLuckyOppoData(mode) {
      // 如果日期为空，不能查询
      if(this.searchCondition.dateRange==null) {
        this.$message("报表查询必须选择日期范围","warning");
        return;
      }
      // 显示页面加载
      const loading = this.$loading({
        lock: true,//lock的修改符--默认是false
        text: 'Loading',//显示在加载图标下方的加载文案
        spinner: 'el-icon-loading',//自定义加载图标类名
        background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
        target: '.box'//遮罩区域
      });
      // 获取请求参数
      let params = new Object();
      let paramsSerial = '';
      params['pageIndex'] = this.pageTable.pageIndex;
      params['pageSize'] = this.pageTable.pageSize;
      params['operatorId'] = this.operator.operatorId;
      paramsSerial += '&operatorId=' + this.operator.operatorId;
      if(this.searchCondition.appIds!=null && this.searchCondition.appIds.length>0) {
        let appIdsSerial = JSON.stringify(this.searchCondition.appIds);
        appIdsSerial = ',' + appIdsSerial.substring(1,appIdsSerial.length - 1) + ',';
        params['appIds'] = appIdsSerial;
        paramsSerial += '&appIds=' + appIdsSerial;
      }
      if(this.searchCondition.appType!=null) {
        params['appType'] = this.searchCondition.appType;
        paramsSerial += '&appType=' + this.searchCondition.appType;
      }
      if(this.searchCondition.dateRange!=null && this.searchCondition.dateRange[0]!=null) {
        params['beginDate'] = moment(this.searchCondition.dateRange[0]).format('YYYY-MM-DD');
        paramsSerial += '&beginDate=' + params['beginDate'];
      }
      if(this.searchCondition.dateRange!=null && this.searchCondition.dateRange[1]!=null) {
        params['endDate'] = moment(this.searchCondition.dateRange[1]).format('YYYY-MM-DD');
        paramsSerial += '&endDate=' + params['endDate'];
      }
      if(this.searchCondition.channelId!=null) {
        params['channelId'] = this.searchCondition.channelId;
        paramsSerial += '&channelId=' + params['channelId'];
      }
      if(this.searchCondition.channelSlotId!=null) {
        params['channelSlotId'] = this.searchCondition.channelSlotId;
        paramsSerial += '&channelSlotId=' + params['channelSlotId'];
      }
      if(this.searchCondition.issuePlatform!=null && this.searchCondition.issuePlatform!='') {
        params['issuePlatform'] = this.searchCondition.issuePlatform;
        paramsSerial += '&issuePlatform=' + params['issuePlatform'];
      }
      if(this.searchCondition.issueFlow!=null && this.searchCondition.issueFlow!='') {
        params['issueFlow'] = this.searchCondition.issueFlow;
        paramsSerial += '&issueFlow=' + params['issueFlow'];
      }
      if(this.searchCondition.issueAccount!=null && this.searchCondition.issueAccount!='') {
        params['issueAccount'] = this.searchCondition.issueAccount;
        paramsSerial += '&issueAccount=' + params['issueAccount'];
      }
      if(this.searchCondition.measureId!=null) {
        params['measureId'] = this.searchCondition.measureId;
        paramsSerial += '&measureId=' + params['measureId'];
      }
      if(this.searchCondition.businessLine!=null) {
        params['businessLine'] = this.searchCondition.businessLine;
        paramsSerial += '&businessLine=' + params['businessLine'];
      }
      if(this.searchCondition.issueEffect!=null) {
        params['issueEffect'] = this.searchCondition.issueEffect;
        paramsSerial += '&issueEffect=' + params['issueEffect'];
      }
      if(this.searchCondition.reportType!=null && this.searchCondition.reportType!='') {
        params['reportType'] = this.searchCondition.reportType;
        paramsSerial += '&reportType=' + params['reportType'];
      }
      if(this.searchCondition.dimensions!=null && this.searchCondition.dimensions.length>0) {
        if (!this.isShowIncrement) {//无需携带额外参数
          this.searchCondition.dimensions = this.searchCondition.dimensions.filter(v => v != '12'&&v != '13');
        }
        params['dimensions'] = ',' + this.searchCondition.dimensions.join(',') + ',';
        paramsSerial += '&dimensions=' + params['dimensions'];
      }
      // 基于不同模式分别处理
      if(mode==undefined || mode==1) {
        // 调用接口
        let res = await this.$api.apiLuckyStatOppo(params);
        if(res.result !== 1) {
          this.$message("加载快应用营销报表失败","warning");
          // 加载结束
          loading.close();
          return;
        }
        // 需要展示roi列，数据过滤
        if (this.isShowROIColumn) {
          const records = res.content.records.filter(v => v.estimate_roi<1 && v.estimate_roi)
          this.pageTable.tableData = records;
          this.pageTable.recordTotalCount = records.length;
          this.pageTable.pageCount = Math.ceil(records.length / this.pageTable.pageSize);
          this.pageTable.pageSize = res.content.pageSize;
          this.pageTable.pageIndex = res.content.pageIndex;
        } else {
          // 获取分页数据
          this.pageTable.pageIndex = res.content.pageIndex;
          this.pageTable.pageSize = res.content.pageSize;
          this.pageTable.pageCount = res.content.pageCount;
          this.pageTable.recordTotalCount = res.content.recordTotalCount;
          // 应用数据存进data
          this.pageTable.tableData = res.content.records;
        }
      } else {
        let target = '/api/console/v1/running/luckystat/oppo/download?' + paramsSerial.substring(1);
        window.open(target, '_blank');
      }
      // 加载结束
      loading.close();
    },

    // 手工数据
    async onManual() {
      // 进入新增页面
      this.$router.push({name:'running.luckystat.lom.manual', params:this.searchCondition});
    },
    
    // 下载
    async onDownload() {
      // 先清空原有数据
      this.tableData = [];
      // 下载数据
      this.getStatLuckyOppoData(2);
    },
    
    // 搜索
    async onSearch() {
      // 保存查询条件
      localStorage.setItem('sc.quickstat.market', JSON.stringify({
        'data': this.searchCondition,
        'timestamp': new Date().getTime()
      }));
      // 先清空原有数据
      this.tableData = [];
      // 查询数据
      this.getStatLuckyOppoData(1);
    },

    // 变更当前页面
    async changeCurrPage(currPage) {
      this.pageTable.pageIndex = currPage;
      this.getStatLuckyOppoData(1);
    },

    // 变更页面大小
    async changePageSize(pageSize) {
      this.pageTable.pageSize = pageSize;
      this.pageTable.pageIndex = 1;
      this.getStatLuckyOppoData(1);
    },
    
    getInitDate(){
      if(this.searchCondition.dateRange!=null 
          && this.searchCondition.dateRange!=undefined 
          && this.searchCondition.dateRange.length>0) {
        return;
      }
      
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth() + 1;
      let day = nowDate.getDate();

      let befDate = new Date();
      befDate=befDate.setDate(befDate.getDate() - 3);
      befDate=new Date(befDate)
      let byear = befDate.getFullYear();
      let bmonth = befDate.getMonth() + 1;
      let bday = befDate.getDate();

      // 默认日期赋值
      this.searchCondition.dateRange = [new Date(byear + ', ' + bmonth + ', ' + bday),new Date(year + ', ' + month + ', ' + day)];
    },

    // 配置投放效果数据回传调整
    async configEffectModeChange() {
      // 效果数据回传模式
      this.effectModeSelected = [];
      this.effectModeSelected2 = [];
      if(this.formConfigEffect.effectMode) {
        this.formConfigEffect.effectMode = parseInt(this.formConfigEffect.effectMode);
        if(Math.floor(this.formConfigEffect.effectMode % 10) == 1) {
          this.effectModeSelected.push('广告点击');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 10) % 10) == 1) {
          this.effectModeSelected.push('广告曝光');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 100) % 10) == 1) {
          this.effectModeSelected.push('用户ARPU');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 100) % 10) == 2) {
          this.effectModeSelected2.push('用户ARPU2');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 1000) % 10) == 1) {
          this.effectModeSelected.push('广告价格');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 1000) % 10) == 2) {
          this.effectModeSelected2.push('广告价格2');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 10000) % 10) == 1) {
          this.effectModeSelected.push('访问时长');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 100000) % 10) == 1) {
          this.effectModeSelected.push('广告曝光&价格');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 100000) % 10) == 2) {
          this.effectModeSelected2.push('广告曝光&价格2');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 1000000) % 10) == 1) {
          this.effectModeSelected.push('ROI');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 1000000) % 10) == 2) {
          this.effectModeSelected2.push('收入ROI');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 10000000) % 10) == 1) {
          this.effectModeSelected2.push('广告点击&价格');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 100000000) % 10) == 1) {
          this.effectModeSelected2.push('ROI修正');
        }
      }
    },

    // 配置渠道位置回传
    async configEffect(channelSlotId) {
      if(channelSlotId==null || channelSlotId==undefined) {
        this.$message("请选择具体渠道位置","warning");
        return;
      }
      // 显示页面加载
      const loading = this.$loading({
          lock: true,
          text: 'Processing ......',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
          target: '.box'
      });
      // 调用接口
      let res = await this.$api.apiCommonEffectGet({channelSlotId: channelSlotId});
      console.log(res);
      if(res.result==1) {
        this.formConfigEffect = res.content;
        this.dialogConfigEffectVisible = true;
        // 效果数据回传模式
        this.effectModeSelected = [];
        this.effectModeSelected2 = [];
        if(this.formConfigEffect.effectMode) {
          this.formConfigEffect.effectMode = parseInt(this.formConfigEffect.effectMode);
          if(Math.floor(this.formConfigEffect.effectMode % 10) == 1) {
            this.effectModeSelected.push('广告点击');
          }
          if(Math.floor((this.formConfigEffect.effectMode / 10) % 10) == 1) {
            this.effectModeSelected.push('广告曝光');
          }
          if(Math.floor((this.formConfigEffect.effectMode / 100) % 10) == 1) {
            this.effectModeSelected.push('用户ARPU');
          }
          if(Math.floor((this.formConfigEffect.effectMode / 100) % 10) == 2) {
            this.effectModeSelected2.push('用户ARPU2');
          }
          if(Math.floor((this.formConfigEffect.effectMode / 1000) % 10) == 1) {
            this.effectModeSelected.push('广告价格');
          }
          if(Math.floor((this.formConfigEffect.effectMode / 1000) % 10) == 2) {
            this.effectModeSelected2.push('广告价格2');
          }
          if(Math.floor((this.formConfigEffect.effectMode / 10000) % 10) == 1) {
            this.effectModeSelected.push('访问时长');
          }
          if(Math.floor((this.formConfigEffect.effectMode / 100000) % 10) == 1) {
            this.effectModeSelected.push('广告曝光&价格');
          }
          if(Math.floor((this.formConfigEffect.effectMode / 100000) % 10) == 2) {
            this.effectModeSelected2.push('广告曝光&价格2');
          }
          if(Math.floor((this.formConfigEffect.effectMode / 1000000) % 10) == 1) {
            this.effectModeSelected.push('ROI');
          }
          if(Math.floor((this.formConfigEffect.effectMode / 1000000) % 10) == 2) {
            this.effectModeSelected2.push('收入ROI');
          }
          if(Math.floor((this.formConfigEffect.effectMode / 10000000) % 10) == 1) {
            this.effectModeSelected2.push('广告点击&价格');
          }
          if(Math.floor((this.formConfigEffect.effectMode / 100000000) % 10) == 1) {
            this.effectModeSelected2.push('ROI修正');
          }
        }
        // 效果回传比例
        if(this.formConfigEffect.effectRate) {
          this.formConfigEffect.effectRate = this.formConfigEffect.effectRate / 100;
        }
        // 效果回传价格
        if(this.formConfigEffect.effectArpu) {
          this.formConfigEffect.effectArpu = this.formConfigEffect.effectArpu / 10000.0;
        }
        if(this.formConfigEffect.effectArpu2) {
          this.formConfigEffect.effectArpu2 = this.formConfigEffect.effectArpu2 / 10000.0;
        }
        if(this.formConfigEffect.effectAdPrice) {
          this.formConfigEffect.effectAdPrice = this.formConfigEffect.effectAdPrice / 10000.0;
        }
        if(this.formConfigEffect.effectRoi) {
          this.formConfigEffect.effectRoi = this.formConfigEffect.effectRoi / 10000.0;
        }
        // 效果回传忽略设备
        if((this.formConfigEffect.effectIgnore & 1) == 1) {
          this.effectIgnoreOppo = true;
        } else {
          this.effectIgnoreOppo = false;
        }
        if((this.formConfigEffect.effectIgnore & 2) == 2) {
          this.effectIgnoreVivo = true;
        } else {
          this.effectIgnoreVivo = false;
        }
        // 统一回传
        if(this.formConfigEffect.effectUnify == 1) {
          this.effectUnifySwitch = true;
        } else {
          this.effectUnifySwitch = false;
        }
      }
      // 关闭加载
      loading.close();
    },
    
    async onCancelConfigEffect() {
      this.dialogConfigEffectVisible = false;
    },

    async submitConfigEffect(form){
      // 验证表单数据
      this.$refs[form].validate((valid) => {
          if (valid) {
            // 显示页面加载
            const loading = this.$loading({
                lock: true,
                text: 'Processing ......',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
                target: '.box'
            });
            // 设置效果回传模式
            let selectedArpu = 0;
            let selectedArpu2 = 0;
            let selectedAdPrice = 0;
            let selectedAdPrice2 = 0;
            let selectedAdPriceView = 0;
            let selectedAdPriceView2 = 0;
            let selectedROI = 0;
            let selectedIncomeRoi = 0;
            let selectedROIAmend = 0;
            this.formConfigEffect.effectMode = 0;
            for(let mode of this.effectModeSelected) {
              if(mode == '广告点击') {
                this.formConfigEffect.effectMode += 1;
              } else if(mode == '广告曝光') {
                this.formConfigEffect.effectMode += 10;
              } else if(mode == '用户ARPU') {
                this.formConfigEffect.effectMode += 100;
                selectedArpu = 1;
              } else if(mode == '广告价格') {
                this.formConfigEffect.effectMode += 1000;
                selectedAdPrice = 1;
              } else if(mode == '访问时长') {
                this.formConfigEffect.effectMode += 10000;
              } else if(mode == '广告曝光&价格') {
                this.formConfigEffect.effectMode += 100000;
                selectedAdPriceView = 1;
              } else if(mode == 'ROI') {
                selectedROI = 1;
                this.formConfigEffect.effectMode += 1000000;
              }
            }
            for(let mode of this.effectModeSelected2) {
              if(mode == '用户ARPU2') {
                this.formConfigEffect.effectMode += 200;
                selectedArpu2 = 1;
              } else if(mode == '广告价格2') {
                this.formConfigEffect.effectMode += 2000;
                selectedAdPrice2 = 1;
              } else if(mode == '广告曝光&价格2') {
                this.formConfigEffect.effectMode += 200000;
                selectedAdPriceView2 = 1;
              } else if(mode == '广告点击&价格') {
                this.formConfigEffect.effectMode += 10000000;
              } else if(mode == '收入ROI') {
                this.formConfigEffect.effectMode += 2000000;
                selectedIncomeRoi = 1;
              } else if(mode == 'ROI修正') {
                selectedROIAmend = 1;
                this.formConfigEffect.effectMode += 100000000;
              }
            }
            // 校验选择合理性
            if(selectedArpu==1 && selectedArpu2==1
                || selectedAdPrice==1 && selectedAdPrice2==1
                || selectedAdPriceView==1 && selectedAdPriceView2==1
                || selectedROI==1 && (selectedIncomeRoi==1 || selectedROIAmend==1)
                || selectedIncomeRoi==1 && (selectedROI==1 || selectedROIAmend==1)
                || selectedROIAmend==1 && (selectedROI==1 || selectedIncomeRoi==1)
              ) {
              this.$message('回调模式选择冲突', "warning");
              // 关闭加载
              loading.close();
              return;
            }
            // 广告曝光和价格与广告价格不能同时选择
            if((selectedAdPrice==1 || selectedAdPrice2==1) && (selectedAdPriceView==1 || selectedAdPriceView2==1)) {
              this.$message('回调模式选择冲突', "warning");
              // 关闭加载
              loading.close();
              return;
            }
            // roi 必须跟其他模式并存
            if(this.formConfigEffect.effectMode == 1000000 || this.formConfigEffect.effectMode == 2000000 || this.formConfigEffect.effectMode == 100000000) {
              this.$message('ROI回传模型必须与其他模式并存', "warning");
              // 关闭加载
              loading.close();
              return;
            }
            // 回传比例
            this.formConfigEffect.effectRate = Math.floor(this.formConfigEffect.effectRate * 100);
            // 效果回传价格
            if(this.formConfigEffect.effectArpu) {
              this.formConfigEffect.effectArpu = Math.floor(this.formConfigEffect.effectArpu * 10000);
            }
            if(this.formConfigEffect.effectArpu2) {
              this.formConfigEffect.effectArpu2 = Math.floor(this.formConfigEffect.effectArpu2 * 10000);
            }
            if(this.formConfigEffect.effectAdPrice) {
              this.formConfigEffect.effectAdPrice = Math.floor(this.formConfigEffect.effectAdPrice * 10000);
            }
            if(this.formConfigEffect.effectDuration) {
              this.formConfigEffect.effectDuration = Math.floor(this.formConfigEffect.effectDuration);
            }
            if(this.formConfigEffect.effectRoi && this.formConfigEffect.effectRoi > 0) {
              this.formConfigEffect.effectRate = 0;  // ROI 回传模型轮询回传比例为 0%
              this.formConfigEffect.effectRoi = Math.floor(this.formConfigEffect.effectRoi * 10000);
            }
            // 忽略设备
            this.formConfigEffect.effectIgnore = 0;
            if(this.effectIgnoreOppo) {
              this.formConfigEffect.effectIgnore += 1;
            }
            if(this.effectIgnoreVivo) {
              this.formConfigEffect.effectIgnore += 2;
            }
            // 统一回传
            if(this.effectUnifySwitch) {
              this.formConfigEffect.effectUnify = 1;
            } else {
              this.formConfigEffect.effectUnify = 0;
            }
            // 设置操作员ID
            let operator = JSON.parse(localStorage.getItem('operator'));
            this.formConfigEffect.operatorId = operator.operatorId;
            // 提交保存
            this.$api.apiCommonEffectSet(this.formConfigEffect).then (res => {
                if (res.result === 1) {
                    // 请求成功
                    this.$message("保存效果数据回传设置成功", "success");
                } else {
                    this.$message(res.message, "warning");
                }
            });
            // 关闭加载
            loading.close();
            // 关闭弹窗
            this.dialogConfigEffectVisible = false;
          }
      });
    },

    async changeChannelSlot() {
      this.editChannelSlotId = this.formConfigEffect.channelSlotId;
      this.editStatChanneSlot = true;
    },

    async confirmChannelSlot() {
      this.editStatChanneSlot = false;
      this.configEffect(this.formConfigEffect.channelSlotId);
    },
    
    async cancelChannelSlot() {
      this.formConfigEffect.channelSlotId = this.editChannelSlotId;
      this.editStatChanneSlot = false;
    },

    // 操作日志
    async showOperateLogs() {
      this.dialogOperateLogVisible = true;
      this.loadOperateLogs();
    },

    async loadOperateLogs() {
      // 显示页面加载
      const loading = this.$loading({
        lock: true,//lock的修改符--默认是false
        text: 'Loading',//显示在加载图标下方的加载文案
        spinner: 'el-icon-loading',//自定义加载图标类名
        background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
        target: '.box'//遮罩区域
      });
      // 获取请求参数
      let params = new Object();
      params['pageIndex'] = this.operateLogs.pageIndex;
      params['pageSize'] = this.operateLogs.pageSize;
      params['beginDate'] = getBeforeDate(this.operateLogs.dateRange);
      params['endDate'] = getCurrDate();
      params['changeTarget'] = 'APP_EFFECT';
      params['changeType'] = 'redis';
      params['changeParam1Key'] = 'csid';
      params['changeParam1Value'] = this.formConfigEffect.channelSlotId;
      // 调用接口
      let res = await this.$api.apiCommonOperateLogs(params);
      if(res.result !== 1) {
        this.$message("加载操作日志失败","warning");
        // 加载结束
        loading.close();
        return;
      }
      // 获取分页数据
      this.operateLogs.pageIndex = res.content.pageIndex;
      this.operateLogs.pageSize = res.content.pageSize;
      this.operateLogs.pageCount = res.content.pageCount;
      this.operateLogs.recordTotalCount = res.content.recordTotalCount;
      // 应用数据存进data
      this.operateLogs.tableData = res.content.records;
      // 加载结束
      loading.close();
    },

    async changeOperateLogCurrPage(currPage) {
      this.operateLogs.pageIndex = currPage;
      this.loadOperateLogs();
    },

    async changeOperateLogPageSize(pageSize) {
      this.operateLogs.pageSize = pageSize;
      this.operateLogs.pageIndex = 1;
      this.loadOperateLogs();
    },
  },
};
</script>
<style lang='scss' scoped>
.box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-wrap: nowrap;
  align-items: center;
  overflow: auto;
}
.work {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  overflow: auto;
}
.path {
  margin: 10px 5px 0px 15px;
  padding: 0px;
  width: 100%;
  height: 20px;
  color: rgb(6, 6, 31);
  font-size: 1rem;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
}
.path_img {
  margin-right:5px;
  height: 15px;
  width: 15px;
}
.path_txt {
  width: 100%;
  height: 20px;
  text-align: left;
}
.condition {
  margin: 10px 10px 10px 10px;
  padding: 5px 5px 5px 5px;
  width: 98%;
  height: auto;
  display: flex;
  flex-direction: row column;
  justify-content: flex-start;
  flex-wrap: wrap;
  background: #fff;
  border-radius: 9px;
  align-items: center;
}
.condi_line {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row column;
  background: #fff;
  border-radius: 9px;
  align-items: center;
}
.condi_item {
  margin-left: 30px;
  width: 260px;
  height: 36px;
  display: flex;
  align-items: center;
}
.condi_item_max {
  margin-left: 30px;
  width: 330px;
  height: 36px;
  display: flex;
  align-items: center;
}
.condi_item_label {
  text-align: left;
  width: 80px;
  font-size: 16px;
}
.condi_item_cnt {
  width: 160px;
  font-size: 16px;
}
.condi_item_cnt_max {
  width: 230px;
  font-size: 16px;
}
.condi_item_cnt .el-input {
  width: 160px;
}
.condi_item_cnt_max .el-input {
  width: 230px;
}
.condi_item_cnt .el-select {
  width: 160px;
}
.condi_item_cnt_max .el-select {
  width: 230px;
}
.condi_item_cnt .el-button {
  width: 160px;
}
.condi_item_cnt_max .el-date-picker {
  width: 230px;
}
.datalist {
  margin: 0px 10px 10px 10px;
  padding: 5px 5px 5px 5px;
  width: 98%;
  height: auto;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex-direction: row;
  border-radius: 9px;
  overflow: auto;
  background: #fff;
}
.datalist .el-table {
  margin: 0 auto;
  width: 96%;
}
.dtlst_top {
  margin: 10px 10px 10px 15px;
  width: 96%;
  height: 25px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
  align-items: center;
  background: #fff;
}
.dtlst_title {
  color: black;
  font-size: 1rem;
  font-weight: 500;
  width: 300px;
  height: 25px;
  text-align: left;
}
.dtlst_btn {
  height: 20px;
  width: calc(100% - 100px);
  text-align: right;
}
.dtlst_btn .el-button {
  margin: 0px 0px 0px 0px;
  padding: 0px 0px 0px 0px;
  color: white;
  background: #1890ff;
  height: 25px;
  width: 100px;
}
.dtlst_table {
  width: 98%;
  height: auto;
}
@media (max-width: 768px) {
  .dtlst_table {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .dtlst_table ::v-deep .el-table__body-wrapper {
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch;
  }
}
.dtlst_operation {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.dtlst_pagination {
  margin: 6px 0px;
  width: 96%;
  height: 25px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.table_row_warning {
  background: rgb(226, 150, 8);
}
.table_row_danger {
  color: red;
  background: rgb(241, 3, 3);
}
// 日预算
.account-info-box {
  height: 40px;
  display: flex;
  margin-bottom: 20px;
}
.account-info-item {
  box-sizing: border-box;
  padding: 0 10px;
  background: #f2f4f5;
  margin-right: 50px;
  line-height: 40px;
  height: 40px;
  display: flex;
}
.account-info-txt {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}
.dailycap_mask {
  position: fixed; 
  inset: 0; 
  z-index: 999;
  background: rgba(0,0,0,.45);
  display: flex; 
  align-items: center; 
  justify-content: center;
}
.dailycap {
  width: 680px; 
  background: #fff; 
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0,0,0,.08);
}
.dailycap_header {
  padding: 20px 24px; 
  font-size: 22px; 
  font-weight: 700; 
  color: #111;
  border-bottom: 1px solid #f0f0f0;
}
.dailycap_body {
  padding: 24px;
}
.dailycap_radio_row { 
  display: flex; 
  gap: 40px; 
  align-items: center; 
  margin-bottom: 18px; 
}
.dailycap_radio { 
  display: inline-flex; 
  align-items: center; 
  gap: 12px; 
  font-size: 22px; 
  color: #333; 
  cursor: pointer; 
  user-select: none; 
}
.dailycap_radio input { 
  display: none; 
}
.dailycap_radio input:checked + .radio-dot { 
  border-color: #22c79a;
}
.dailycap_radio input:checked + .radio-dot::after { 
  background: #22c79a; 
}
.dailycap_radio.custom { 
  color: #22c79a; 
}
.dailycap_input_row {
  display: flex; 
  align-items: stretch; 
  border: 1px solid #e5e7eb; 
  border-radius: 10px; 
  overflow: hidden; 
}
.dailycap_input_row input { 
  flex: 1; 
  border: none; 
  outline: none; 
  height: 54px; 
  padding: 0 16px; 
  font-size: 20px; 
}
.dailycap_input_row .input_suffix { 
  width: 120px; 
  background: #f5f7fa; 
  color: #666; 
  display: flex; 
  align-items: center; 
  justify-content: center; 
  font-size: 18px; 
}
.dailycap_input_row.disabled { 
  opacity: .5; 
}
.dailycap_footer { 
  display: flex; 
  justify-content: flex-end; 
  gap: 16px; 
  padding: 20px 24px 24px; 
}
.btn-plain { 
  height: 44px; 
  min-width: 120px; 
  padding: 0 18px; 
  border-radius: 10px; 
  border: 1px solid #d0e9df; 
  background: #fff; 
  color: #22c79a; 
  font-size: 18px; 
  cursor: pointer; 
}
.btn-green { 
  height: 44px; 
  min-width: 140px; 
  padding: 0 22px; 
  border-radius: 10px; 
  border: none; 
  background: #22c79a; 
  color: #fff; 
  font-size: 18px; 
  cursor: pointer; 
}
.text-ellipsis {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>